import { cn, Tooltip, TooltipContent, TooltipTrigger } from '@design-system';
import { useIsEdjPilotAdvisor } from '@/shared/hooks/use-edj-pilot-advisor';

interface EdjPilotRestrictedProps {
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  hidden?: boolean;
  className?: string;
  tooltipText?: string;
}

const TOOLTIP_TEXT =
  'This feature is available on Waterlily but is not part of the Edward Jones pilot program.';

export function EdjPilotRestricted({
  children,
  side,
  hidden = false,
  className,
  tooltipText
}: EdjPilotRestrictedProps) {
  const isRestricted = useIsEdjPilotAdvisor();

  if (!isRestricted) {
    return <>{children}</>;
  }

  if (hidden) {
    return null;
  }

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <div className={cn('cursor-not-allowed', className)}>
          <div
            className="pointer-events-none opacity-50"
            aria-disabled="true"
            onKeyDown={e => e.preventDefault()}
            onFocusCapture={e => e.stopPropagation()}
            tabIndex={-1}
          >
            {children}
          </div>
        </div>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        className="max-w-64"
      >
        {tooltipText ?? TOOLTIP_TEXT}
      </TooltipContent>
    </Tooltip>
  );
}
